var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 15.62,
    viewBox: "0 0 25 15.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.44,15.62a1.57,1.57,0,0,1-1.18-.53L12.5,3.93,2.74,15.09A1.56,1.56,0,1,1,.39,13L11.32.53A1.57,1.57,0,0,1,12.5,0a1.61,1.61,0,0,1,1.18.53L24.61,13a1.57,1.57,0,0,1-.14,2.21,1.55,1.55,0,0,1-1,.38Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.dfa9cc71f6875e2219fd86368edee866.svg";
export { ForwardRef as ReactComponent };